import React, { useState, useEffect, useRef } from 'react';
import { ChevronLeft, ChevronRight } from 'lucide-react';
import './Gallery.css';

const galleryImages = [
  {
    url: 'https://images.unsplash.com/photo-1583847268964-b28dc8f51f92?w=800&h=600&fit=crop',
    alt: 'Clean modern living room'
  },
  {
    url: 'https://images.unsplash.com/photo-1519710164239-da123dc03ef4?w=800&h=600&fit=crop',
    alt: 'Minimalist clean space'
  },
  {
    url: 'https://images.unsplash.com/photo-1605774337664-7a846e9cdf17?w=800&h=600&fit=crop',
    alt: 'Nordic style clean room'
  },
  {
    url: 'https://images.pexels.com/photos/2724749/pexels-photo-2724749.jpeg?w=800&h=600&fit=crop',
    alt: 'Clean kitchen space'
  },
  {
    url: 'https://images.pexels.com/photos/667838/pexels-photo-667838.jpeg?w=800&h=600&fit=crop',
    alt: 'Organized living area'
  },
  {
    url: 'https://images.pexels.com/photos/325876/pexels-photo-325876.jpeg?w=800&h=600&fit=crop',
    alt: 'Organized closet'
  }
];

const Gallery = () => {
  const [isVisible, setIsVisible] = useState(false);
  const [currentIndex, setCurrentIndex] = useState(0);
  const sectionRef = useRef(null);

  useEffect(() => {
    const observer = new IntersectionObserver(
      ([entry]) => {
        if (entry.isIntersecting) {
          setIsVisible(true);
        }
      },
      { threshold: 0.2 }
    );

    if (sectionRef.current) {
      observer.observe(sectionRef.current);
    }

    return () => {
      if (sectionRef.current) {
        observer.unobserve(sectionRef.current);
      }
    };
  }, []);

  const nextSlide = () => {
    setCurrentIndex((prev) => (prev + 1) % galleryImages.length);
  };

  const prevSlide = () => {
    setCurrentIndex((prev) => (prev - 1 + galleryImages.length) % galleryImages.length);
  };

  const goToSlide = (index) => {
    setCurrentIndex(index);
  };

  return (
    <section id="gallery" ref={sectionRef} className="gallery-section">
      <div className="gallery-container">
        <div className={`gallery-content ${isVisible ? 'visible' : ''}`}>
          <div className="section-header">
            <span className="section-badge">Our Work</span>
            <h2 className="section-title">Gallery</h2>
            <p className="section-subtitle">
              See the transformation - before and after our professional cleaning services
            </p>
          </div>

          <div className="carousel-wrapper">
            <div className="carousel-container">
              <div className="carousel-slides" style={{ transform: `translateX(-${currentIndex * 100}%)` }}>
                {galleryImages.map((image, index) => (
                  <div key={index} className="carousel-slide">
                    <img src={image.url} alt={image.alt} className="carousel-image" />
                  </div>
                ))}
              </div>

              <button onClick={prevSlide} className="carousel-button prev">
                <ChevronLeft size={28} />
              </button>
              <button onClick={nextSlide} className="carousel-button next">
                <ChevronRight size={28} />
              </button>
            </div>

            <div className="carousel-indicators">
              {galleryImages.map((_, index) => (
                <button
                  key={index}
                  onClick={() => goToSlide(index)}
                  className={`indicator ${index === currentIndex ? 'active' : ''}`}
                  aria-label={`Go to slide ${index + 1}`}
                />
              ))}
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default Gallery;
